import { useParams } from 'react-router-dom';

export function useGetDocumentId() {
    const { documentId } = useParams();

    return parseInt(documentId);
}
